<script setup>
import { ref, onMounted, watch, defineExpose, defineEmits } from "vue"
import i18n from "@/i18n"
// import { dateFormat1 } from "@/utils/common.js";
import { permission } from '@/utils/permission';
import { useRouter } from "vue-router";
import usetablePageNation from "@/utils/hooks/usetablePageNation" //分页hooks
import Swal from "sweetalert2";
import { getFileUrl } from "@/service"
import { getProductLineList, deleteProductLinefo } from "@/service/apiList/productLine"
import PreviewImg from "@/components/common/PreviewImg";
import { getLangValue, makeQrCode } from "@/utils/common"; //获取后端语言
const emits = defineEmits(['viewDetail', 'editDetail'])
const tableInfo = ref([])
const router = useRouter()
const fileList = ref([])
const activeImageSrc = ref('')
const showPreviewImg = ref(false)
const table_head = ref([
    { name: '#', width: '2%' },
    { name: getLangValue("my.product-line", "searchPlaceholder1"), width: '10%' },
    { name: getLangValue("my.product-line", "table_header"), width: '10%' },
    { name: getLangValue("my.product-line", "table_header1"), width: '6%' },
    { name: getLangValue("my.product-line", "table_header6"), width: '10%' },
    { name: getLangValue("my.product-line", "table_header7"), width: '10%' },
    { name: getLangValue("my.product-line", "table_header2"), width: '10%' },
    { name: getLangValue("my.product-line", "table_header3"), width: '10%' },
    { name: getLangValue("my.product-line", "table_header4"), width: '10%' },
    { name: getLangValue("my.product-line", "table_header5"), width: '20%' },
    { name: getLangValue("base.operation"), width: '5%' },
])
const pageSizeOption = [10, 20, 30, 40, 50]
const loading = ref(false)
const { total, currentPage, pageSize, pageOption } = usetablePageNation(getDataList)
const formValidataAlert = ref(false)
const alertInfo = ref({
    variant: "danger",
    content: "",
    icon: "ri-error-warning-line",
})
const iconObj = {
    danger: "ri-error-warning-line",
    success: "ri-check-line",
    warning: "ri-error-warning-line",
    info: "ri-information-line",
}
const openAlert = (info, time = 3000) => {
    formValidataAlert.value = false;
    if (info.content) {
        alertInfo.value.content = info.content;
        alertInfo.value.icon = iconObj[info.variant] ? iconObj[info.variant] : 'ri-check-line';
        alertInfo.value.variant = info.variant;
        formValidataAlert.value = true;
    }
    setTimeout(
        () => {
            formValidataAlert.value = false;
        },
        time
    );
}
// const templateName = ref("")
const searchData = ref({
    keyword: '',
    template_name: '',
    hscode: [],
})
// const switchChange = async ({ id, enabled }) => {
//     //切换开关
//     console.log(enabled);
//     let params = {
//         status: enabled ? 1 : 0
//     }
//     const resp = await putProductTemplateStatus(id, params)
//     if (resp) {
//         openAlert({
//             variant: resp.code == 1 ? "danger" : 'success',
//             content: resp.code == 1 ? resp.message : getLangValue("base.edit_success"),
//         });
//         //  更新
//         getDataList();
//         sessionStorage.removeItem('t_menuList');
//         //刷新页面
//         window.location.reload();
//     }
// }

const handler = (type, info) => {
    //按钮处理
    switch (type) {
        case 'view':
            // router.push({ name: 'product_template_detail', query: { type: 'view', id: info.id } })
            emits('viewDetail', info)
            // gotoProduct(info)
            break;
        case 'edit':
            // router.push({ name: 'product_template_detail', query: { type: 'edit', id: info.id } })
            emits('editDetail', info)
            break;
        case 'copy':
            // copyData(info)
            break;
        case 'delete':
            deleteData(info)
            break;
    }
}

// const copyData = async ({ id }) => {
//     //复制
//     console.log(id);
//     let params = {
//         templateId: id
//     }
//     const resp = await copyProductTemplate(params)
//     if (resp) {
//         openAlert({
//             variant: resp.code == 1 ? "danger" : 'success',
//             content: resp.code == 1 ? resp.message : getLangValue("base.copy_success"),
//         });
//         //  更新
//         getDataList();
//         sessionStorage.removeItem('t_menuList');
//         //刷新页面
//         window.location.reload();
//     }
// }

const deleteData = async ({ id, production_line_name: name }) => {
    Swal.fire({
        title: getLangValue("base.delete_alert_title") + `${i18n.global.locale == 'ch' ? name + '?' : ''}`,
        text: getLangValue("base.delete_alert_info"),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: getLangValue("base.done"),
        cancelButtonText: getLangValue("base.cancel"),
    }).then(async (result) => {
        if (result.isConfirmed) {
            // console.log(id)
            //延迟2s操作
            let resp = await deleteProductLinefo(id);
            if (resp) {
                openAlert({
                    variant: resp.code == 1 ? "danger" : 'success',
                    content: resp.code == 1 ? resp.message : getLangValue("base.delete_success"),
                });
                //  更新
                getDataList();
                // if (resp.code == 0) {
                //     sessionStorage.removeItem('t_menuList');
                //     //刷新页面
                //     window.location.reload();
                // }

            }
        }
    });
}
const getImageUrl = (id) => {
    let arr = fileList.value.filter(item => item.id === id)
    if (arr.length) {
        return arr[0]
    }
    return ''
}
const getDataList = async () => {
    loading.value = true
    let dataHscode = searchData.value.hscode && searchData.value.hscode.length ? [...searchData.value.hscode] : []
    //获取数据
    let params = {
        page: currentPage.value - 1,
        limit: pageSize.value,
        keyword: searchData.value.keyword,
        hscode: dataHscode.length ? dataHscode.pop() : '',
        template_name: searchData.value.template_name,
        order_by: 'desc',
        sort_field: 'create_time',
    }
    const resp = await getProductLineList(params);
    loading.value = false
    // resp.payload.forEach(element => {
    //     element.enabled = element.status == 1 ? true : false
    // });
    if (resp.payload.total == (currentPage.value - 1) * pageSize.value && currentPage.value > 1) {
        currentPage.value--
        return
    }
    table_head.value[7].name = resp.payload.style_name
    table_head.value[8].name = resp.payload.pattern_name
    tableInfo.value = resp.payload.data;
    total.value = resp.payload.total
    setPages();
    // 获取图片
    let imageList = []
    tableInfo.value.forEach(async item => {
        if (item.style.length)
            imageList.push(item.style[0]);
        if (item.pattern.length)
            imageList.push(item.pattern[0]);
        if (item.plid) {
            // 需要加id plid怎么显示是个问题
            const reps = await makeQrCode({ type: 3, content: item.plid })
            if (reps) {
                item.qrcodeImgUrl = reps
            }
        }
    })
    // console.log(tableInfo.value);
    // 重复图片 去重
    imageList = [...new Set(imageList)]
    let imgStr = imageList.join(',')
    if (imgStr)
        getFileUrl({ attachments: imgStr }).then(resp => {
            if (resp) {
                resp.payload.forEach(item => {
                    item.type = setType(item.name)
                })
                fileList.value = resp.payload
            }
        })
}

const setType = (filename) => {
    // 获取文件类型
    let fileType = filename.split('.').pop()
    if (fileType == 'jpg' || fileType == 'jpeg' || fileType == 'png' || fileType == 'gif') {
        return 'image'
    }
    return 'file'
}
const setPages = () => {
    pageOption.value = [];
    let numberOfPages = Math.ceil(total.value / pageSize.value);
    for (let index = 1; index <= numberOfPages; index++) {
        pageOption.value.push(index);
    }
}

// const setdata = () => {
//     tableData.value = tableInfo.value.slice((currentPage.value - 1) * pageSize.value, currentPage.value * pageSize.value)
// }
const gotoProduct = async (info) => {
    if (!permission('my.product.list')) {
        return false
    }

    let url = router.resolve({
        name: 'products', params: { id: info.database_template.name },
        query: {
            p_id: info.id,
            p_l_no: info.production_line_number,
            p_l_name: info.production_line_name,
            p_l_name_en: info.production_line_name_en,
            h_id: info.database_template.hscode.id,
            p_o_o: info.place_of_origin && info.place_of_origin.id ? info.place_of_origin.id : '',
            style: info.style[0],
            pattern: info.pattern[0],
            status: info.database_template.status,  // status 0 是关闭  1是开启   关闭后无法新增编辑
            role_key: info.database_template.role_key 
        },
    }).href
    window.open(url, '_blank')

    // const resp = await getProductTemplateMenu();
    // let data = sessionStorage.getItem('t_menuList') ? JSON.parse(sessionStorage.getItem('t_menuList')) : []
    // let arr = data.filter(item => item.name === info.template_name)
    // resp.payload.forEach((element) => {
    //     element.id = md5(element.name)
    // })
    // sessionStorage.setItem('t_menuList', JSON.stringify(resp.payload))
    // if (resp.code == 0) {
    // let arr = data.filter(item => item.name === info.template_name)
    // if (arr.length) {
    //     let id = arr[0].id;
    //     router.push({
    //         name: 'products', params: { id: id },
    //         query: {
    //             p_id: info.id,
    //             p_l_no: info.production_line_number,
    //             p_l_name: info.production_line_name,
    //             h_id: info.hscode.id,
    //             p_o_o: info.place_of_origin && info.place_of_origin.id ? info.place_of_origin.id : '',
    //             style: info.style[0],
    //             pattern: info.pattern[0],
    //         },
    //     })
    // } else {
    //     router.push({
    //         name: 'products', params: { id: info.template_name },
    //         query: {
    //             p_id: info.id,
    //             p_l_no: info.production_line_number,
    //             p_l_name: info.production_line_name,
    //             h_id: info.hscode.id,
    //             p_o_o: info.place_of_origin && info.place_of_origin.id ? info.place_of_origin.id : '',
    //             style: info.style[0],
    //             pattern: info.pattern[0],
    //             status: 1, //模板关闭了  模板关闭后 不可以新增编辑
    //         },
    //     })
    // }
    // } else {
    //     openAlert({
    //         variant: "danger",
    //         content: resp.message,
    //     });
    // }

}

// const checkOpen = (info) => {
//     let data = sessionStorage.getItem('t_menuList') ? JSON.parse(sessionStorage.getItem('t_menuList')) : []
//     let arr = data.filter(item => item.name === info.template_name)
//     if (arr.length) {
//         return true
//     }
//     return false
// }

const showImageCode = (url) => {
    /**查看二维码大图 */
    activeImageSrc.value = url;
    if (activeImageSrc.value == "") {
        return;
    }
    showPreviewImg.value = true;
}

watch(pageSize, () => {
    currentPage.value = 1;
    getDataList();
})

watch(currentPage, () => {
    getDataList();
    // setdata()
})

watch(searchData, () => {
    currentPage.value = 1;
    getDataList();
}, { deep: true })

onMounted(() => {
    getDataList()
})
//弹出
defineExpose({
    // templateName,
    searchData,
    getDataList
})
</script>

<template>
    <div class="" v-if="tableInfo.length || loading" style="height: 100%;">
        <!-- Bordered Tables -->
        <div style="height:calc(100% - 50px ); overflow-y: auto;" class="my-scroll-bar" v-loading="loading">
            <table class="table table-bordered table-nowrap mb-0">
                <thead class="table-light">
                    <tr>
                        <th scope="col" v-for="(head, index) in table_head" :key="index" style="color: #878A99;"
                            :width="head.width">
                            {{ head.name }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(info, index) in tableInfo" :key="index" style="vertical-align: middle"
                        @click="gotoProduct(info)">
                        <td>{{ index + 1 }}</td>
                        <td class="cursor-pointer">{{ i18n.global.locale == 'en' ?
                            info.database_template?.name_en : info.database_template?.name }}
                        </td>
                        <td>{{ info.production_line_number }}</td>
                        <td>{{ i18n.global.locale == 'en' ? info.production_line_name_en:  info.production_line_name}}</td>
                        <td>{{ info.place_of_origin ?
                            `${info.place_of_origin.place_of_origin_number}${info.place_of_origin.country}-${info.place_of_origin.province}-${info.place_of_origin.city}`
                            :
                            '' }}</td>
                        <!-- //-${info.place_of_origin.address1} 去掉详细地址 -->
                        <td>{{ i18n.global.locale == 'en' ? info.database_template?.destination_market?.title_en :
                            info.database_template?.destination_market?.title}}</td>
                        <td>
                            <!-- {{ info.plid }} -->
                            <img class="cursor-pointer" :src="info.qrcodeImgUrl" v-if="info.qrcodeImgUrl"
                                style="width: 40px;" @click.stop="showImageCode(info.qrcodeImgUrl)" />
                        </td>
                        <td>
                            <img style="width: 50px; height: 40px;"
                                @click.stop="showImageCode(getImageUrl(info.style[0]).url)"
                                v-if="info.style.length && fileList.length && getImageUrl(info.style[0]).type == 'image'"
                                :src="getImageUrl(info.style[0]).url" class="cursor-pointer">
                            <i class="ri-file-text-line fs-36" style="color: #3577f1;"
                                v-if="info.style.length && fileList.length && getImageUrl(info.style[0]).type == 'file'"></i>
                        </td>
                        <td>
                            <img style="width: 60px;height: 48px;"
                                @click.stop="showImageCode(getImageUrl(info.pattern[0]).url)"
                                v-if="info.pattern.length && fileList.length && getImageUrl(info.pattern[0]).type == 'image'"
                                :src="getImageUrl(info.pattern[0]).url" class="cursor-pointer">
                            <i class="ri-file-text-line fs-36" style="color: #3577f1;"
                                v-if="info.pattern.length && fileList.length && getImageUrl(info.pattern[0]).type == 'file'"></i>
                        </td>
                        <td :class="i18n.global.locale == 'en' ? 'en-word-break' : 'zh-word-break'"
                            style="max-width: 150px; white-space: normal;">{{ info.database_template ?
                                `${i18n.global.locale == 'en' ? info.database_template?.hscode?.title_en :
                                    info.database_template?.hscode?.title}--${i18n.global.locale == 'en' ?
                                        info.database_template?.hscode?.description_en :
                            info.database_template?.hscode?.description}` : '' }}</td>
                        <td @click.stop="() => { }">
                            <template class="d-flex align-items-center">
                                <div class="dropdown"
                                    style="background-color: rgba(53, 119, 241, 0.098); text-align: center; width: 30px; height: 30px; line-height: 30px;">
                                    <a style="display: block; width: 100%; height: 100%;" href="#" role="button"
                                        id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false"><i
                                            class="ri-more-line"></i></a>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                        <li>
                                            <div v-permit="'my.production-line.show'"
                                                class="dropdown-item cursor d-flex align-items-center"
                                                @click.stop="handler('view', info)">
                                                <i class="fs-16 ri-eye-fill text-primary me-2"></i> {{
                                                    getLangValue("base.to_view") }}
                                            </div>
                                        </li>
                                        <li>
                                            <div v-permit="'my.production-line.modify'"
                                                class="dropdown-item cursor d-flex align-items-center"
                                                @click.stop="handler('edit', info)">
                                                <i class="fs-16 ri-pencil-fill text-primary me-2"></i> {{
                                                    getLangValue("base.edit") }}
                                            </div>
                                        </li>
                                        <li class="dropdown-divider" v-permit="'my.production-line.delete'"></li>
                                        <li>
                                            <div v-permit="'my.production-line.delete'"
                                                class="dropdown-item cursor d-flex align-items-center"
                                                @click.stop="handler('delete', info)">
                                                <i class="fs-16 ri-delete-bin-5-fill text-danger me-2"></i>{{
                                                    getLangValue("base.delete") }}
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <!-- 模板已禁用 0 禁用 1 开启-->
                                <i v-if="info.flag === 1"
                                    class="ri-indeterminate-circle-line ms-2"
                                    :title="getLangValue('my.product-line', 'message')"
                                    style="font-size: 30px;color: #ED4014;"></i>
                            </template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- 分页 -->
        <Pagination v-if="total" v-model:page="currentPage" v-model:perPage="pageSize" :pages="pageOption"
            :prePageOption="pageSizeOption" :tab_info_length="total" class="me-5" style="margin-top: 0 !important;">
        </Pagination>
    </div>
    <div  v-else style="height: 100%;" class="d-flex align-items-center justify-content-center">
        <Empty style="margin-top: 200px;"></Empty>
    </div>
    
    <PreviewImg v-model:showPreviewImg="showPreviewImg" :src="activeImageSrc" :myWidth="400" v-if="showPreviewImg">
    </PreviewImg>
    <message-alert :alertInfo="alertInfo" v-if="formValidataAlert"></message-alert>
</template>
<style scoped>
.table-bordered> :not(caption)>*>* {
    border: unset;
}

/* .table > :not(caption) > * > *{
    padding: 0.75rem 1rem;
} */
.table-bordered td {
    padding: 0.2rem 0.6rem !important;
}

.table-bordered th {
    padding: 0.5rem 0.6rem !important;
}
</style>